<script>
export default {
  methods: {
    track(action, { category, label, value } = {}) {
      if (this.$gtag) {
        this.$gtag.event(action, {
          event_category: category,
          event_label: label,
          value,
        })
      }

      if (this.$analytics && this.$analytics.fbq) {
        this.$analytics.fbq.event(category)
      }
    },
  },
}
</script>
